import React, { useCallback } from 'react';

import { App, Button, Input } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

interface ClipboardFieldProps {
  value: string;
}

const ClipboardField = ({ value }: ClipboardFieldProps) => {
  const { message } = App.useApp();

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      message.success('Link copiado para a área de transferência');
    } catch {
      message.error('Não foi possível copiar o conteúdo');
    }
  }, [message, value]);

  return (
    <Input
      value={value}
      readOnly
      size='small'
      suffix={
        <Button
          type='text'
          size='small'
          shape='circle'
          aria-label='Copiar'
          icon={<Icon.Copy size={14} />}
          onClick={handleCopy}
        />
      }
    />
  );
};

export default ClipboardField;
